/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getFeV1Structures$Json } from '../fn/structure/get-fe-v-1-structures-json';
import { GetFeV1Structures$Json$Params } from '../fn/structure/get-fe-v-1-structures-json';
import { getFeV1Structures$Plain } from '../fn/structure/get-fe-v-1-structures-plain';
import { GetFeV1Structures$Plain$Params } from '../fn/structure/get-fe-v-1-structures-plain';
import { StructureResponseListResponse } from '../models/structure-response-list-response';

@Injectable({ providedIn: 'root' })
export class StructureService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFeV1Structures()` */
  static readonly GetFeV1StructuresPath = '/v1/structures';

  /**
   * Gets all structures.
   *
   * Gets all structures.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Structures$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Structures$Plain$Response(params?: GetFeV1Structures$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StructureResponseListResponse>> {
    return getFeV1Structures$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all structures.
   *
   * Gets all structures.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Structures$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Structures$Plain(params?: GetFeV1Structures$Plain$Params, context?: HttpContext): Observable<StructureResponseListResponse> {
    return this.getFeV1Structures$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StructureResponseListResponse>): StructureResponseListResponse => r.body)
    );
  }

  /**
   * Gets all structures.
   *
   * Gets all structures.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Structures$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Structures$Json$Response(params?: GetFeV1Structures$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StructureResponseListResponse>> {
    return getFeV1Structures$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all structures.
   *
   * Gets all structures.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Structures$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Structures$Json(params?: GetFeV1Structures$Json$Params, context?: HttpContext): Observable<StructureResponseListResponse> {
    return this.getFeV1Structures$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StructureResponseListResponse>): StructureResponseListResponse => r.body)
    );
  }

}
